<!-- 排产操作日志 -->
<style scoped="scoped" lang="scss"></style>
<style lang="scss">
.el-select .el-input {
  width: auto;
}
</style>
<style lang="scss" scoped="">
// .testMoldTable {
//   margin-top: 10px;
//   text-align: center !important;
// }

// .testMoldTable /deep/ table {
//   color: #303133 !important;
// }

// .testMoldTable /deep/ table tbody tr:first-child {
//   background-color: #909399 !important;
//   color: #FFFFFF IM !important;
// }


.container::-webkit-scrollbar {
  display: none;
}


.testMoldTable {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
  border: none !important;
}

.testMoldTable /deep/ table {
  border-collapse: collapse;
  border-color: rgb(232, 232, 232);
}

.testMoldTable /deep/ table tbody tr:first-child {
  height: 26px;
  font-size: 12px;
  background: rgb(123, 127, 128);
}

.testMoldTable /deep/ table tbody tr:not(:first-child) {
  height: 26px;
  font-size: 12px;
  color: #606672;
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/trial/mould/wo/page" getKey="rows" :columns="columns">


      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shimojihuadanhao')">
            <el-input v-model="yt.conditions.planNo"></el-input>
          </el-form-item>

          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIds"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('shezuimingcheng')">
            <yi_data_select :multiple="true" :type="'mouth'" :ids.sync="yt.conditions.shootingMouthIds"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('mojumingcheng')">
            <yi_data_select :multiple="true" :type="'mould'" :ids.sync="yt.conditions.mouldIds"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('wuliaomingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"></yi_data_select>
          </el-form-item>


          <el-form-item :label="$t('danjuzhuangtai')">
            <yi_dictionary_select :type="'TRIAL_MOULD_WO_STATUS'" :ids.sync="yt.conditions.statusList" :multiple="true" :max="999"> </yi_dictionary_select>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ createTimeStart: createTimeStart, createTimeEnd: createTimeEnd, orderBy: 'id desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" type="primary" @click="yt.showEditDialog('xinzeng', null, 'w1')">
          {{ $t('xinzeng') }}
        </el-button>

      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #lilungongyika="scope">
        <yi_upload :readOnly="true" :ids.sync="scope.row.fileIds" :limit="10"></yi_upload>
      </template>
      <!-- 1-待试模,2-调试中,3-试模中,4-已完成,5-暂停中 -->
      <template #caozuo="scope">
        <el-button v-if="scope.row.status == 1 || scope.row.status == 5" type="text" @click="yt.editObj = scope.row; yt.req('POST', '/web/trial/mould/wo/start?id=' + scope.row.id)">{{ $t('kaishishimo') }} </el-button>
        <el-button v-if="scope.row.status == 1" type="text" @click="yt.showEditDialog('bianji', scope.row)">{{ $t('bianji') }} </el-button>
        <el-button v-if="scope.row.status == 2 || scope.row.status == 3" type="text" @click="yt.showEditDialog('shimojindu', scope.row, '80%'); refreshProgressDialog()">{{ $t('shimojindu') }} </el-button>
        <el-button v-if="scope.row.status == 4" type="text" @click="activeTab = '0'; yt.showEditDialog('chakan', scope.row, '80%'); refreshProgressDialog()">{{ $t('chakan') }} </el-button>
        <el-button v-if="scope.row.status == 2" type="text" @click="yt.editObj = scope.row; yt.req('POST', '/web/trial/mould/wo/pause?id=' + scope.row.id)">{{ $t('zanting') }} </el-button>
        <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/trial/mould/wo/delete', null, '是否删除该试模工单？删除后数据不可恢复')">{{ $t('shanchu') }} </el-button>

      </template>
    </yi_curd_table>
    <!-- 公共弹框：新增/编辑等动作共用 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body" @close="handleDialogClose">
      <!-- 新增 -->
      <template v-if="yt.editObj && yt.editObj.action === 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="'147px'" :model="yt.editObj">
          <el-form-item :label="$t('shimojihuadanhao')" required>
            <el-input v-model="yt.editObj.planNo"></el-input>
          </el-form-item>

          <el-form-item :label="$t('shezuimingcheng')" required>
            <yi_data_select :type="'mouth'" :ids.sync="yt.editObj.shootingMouthId"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('wuliaomingcheng')" required>
            <yi_data_select :type="'material2'" :ids.sync="yt.editObj.materialId"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('mojumingcheng')" required>
            <yi_data_select :type="'mould'" :ids.sync="yt.editObj.mouldId"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('shebeimingcheng')" required>
            <yi_data_select :type="'equipment'" :ids.sync="yt.editObj.equipmentId"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('lilungongyika')">
            <yi_upload :accept="'application/pdf,image/png,image/jpeg,image/gif'" :ids.sync="yt.editObj.fileIds" :limit="10">
              <div slot="limitMsg"></div>
            </yi_upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="createWo" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <!-- 编辑 -->
      <template v-else-if="yt.editObj && yt.editObj.action === 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="'147px'" :model="yt.editObj">
          <el-form-item :label="$t('shimojihuadanhao')" required>
            <el-input v-model="yt.editObj.planNo"></el-input>
          </el-form-item>

          <el-form-item :label="$t('shezuimingcheng')" required>
            <yi_data_select :type="'mouth'" :ids.sync="yt.editObj.shootingMouthId"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('wuliaomingcheng')" required>
            <yi_data_select :type="'material2'" :ids.sync="yt.editObj.materialId"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('mojumingcheng')" required>
            <yi_data_select :type="'mould'" :ids.sync="yt.editObj.mouldId"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('shebeimingcheng')" required>
            <yi_data_select :type="'equipment'" :ids.sync="yt.editObj.equipmentId"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('lilungongyika')">
            <yi_upload :accept="'application/pdf,image/png,image/jpeg,image/gif'" :ids.sync="yt.editObj.fileIds" :limit="10">
              <div slot="limitMsg"></div>
            </yi_upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="updateWo" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <!-- 试模进度查看 -->
      <template v-else-if="yt.editObj && yt.editObj.action === 'chakan'">
        <div class="dialog-scroller">
          <el-descriptions :column="3" size="mini">
            <el-descriptions-item :label="$t('wuliaomingcheng') + '/' + $t('wuliaobianma')">
              {{ yt.editObj.material && yt.editObj.material.name }} / {{ yt.editObj.material && yt.editObj.material.code }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('mojumingcheng') + '/' + $t('mujubianma')">
              {{ yt.editObj.mould && yt.editObj.mould.name }} / {{ yt.editObj.mould && yt.editObj.mould.code }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('shezuimingcheng') + '/' + $t('shezuibianma')">
              <div style="display: flex;align-items: center;">
                <p> {{ yt.editObj.shootingMouth && yt.editObj.shootingMouth.name }} / {{ yt.editObj.shootingMouth && yt.editObj.shootingMouth.code }}</p>
              </div>

            </el-descriptions-item>
            <el-descriptions-item :label="$t('danjuzhuangtai')">
              {{ $t(store.state.dictJsonAll['TRIAL_MOULD_WO_STATUS'][yt.editObj.status]) }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('shebeimingcheng') + '/' + $t('shebeibianma')">
              {{ yt.editObj.equipment && yt.editObj.equipment.name }} / {{ yt.editObj.equipment && yt.editObj.equipment.sn }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('lilungongyika')">
              <yi_upload :readOnly="true" :ids.sync="yt.editObj.fileIds" :limit="10"></yi_upload>
            </el-descriptions-item>
          </el-descriptions>
          <div style="padding: 40px 0px;">
            <el-steps :active="Number(yt.editObj.currentStep)" align-center finish-status="success">
              <el-step title="空射调试">
                <template #description>
                  <span>
                    <span v-if="yt.editObj.stepOneFinishTime">{{ dayjs(yt.editObj.stepOneFinishTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                  </span>
                </template>
              </el-step>
              <el-step title="开始试模">
                <template #description>
                  <span>
                    <span v-if="yt.editObj.stepTwoFinishTime">{{ dayjs(yt.editObj.stepTwoFinishTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                  </span>
                </template>
              </el-step>
              <el-step title="分段采集">
                <template #description>
                  <span v-if="yt.editObj.stepThreeFinishTime">{{ dayjs(yt.editObj.stepThreeFinishTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                </template>
              </el-step>
              <el-step title="完成试模">
                <template #description>
                  <span v-if="yt.editObj.stepFourFinishTime">{{ dayjs(yt.editObj.stepFourFinishTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                </template>
              </el-step>
            </el-steps>
          </div>
          <el-tabs v-model="activeTab" style="margin-top: 20px;">
            <el-tab-pane :label="$t('kongshetiaoshi')">
              <div style="padding:20px 0px;">
                <div style="margin: 8px 0;font-weight: 600;">{{ $t('baojingshuju') }}</div>
                <el-table :data="(yt.editObj && yt.editObj.realTimeAlerts) ? yt.editObj.realTimeAlerts : []" size="mini" border style="width: 100%">
                  <el-table-column type="index" :label="$t('xuhao')" width="60"></el-table-column>
                  <el-table-column :label="$t('baojingxinxi')">
                    <template #default="{ row }">
                      {{ row.i18n ? $t(row.i18n) : row.code }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('baojingshijian')" width="180">
                    <template #default="{ row }">
                      {{ row.alarmTime ? dayjs(row.alarmTime).format('YYYY-MM-DD HH:mm:ss') : '' }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div style="padding:20px 0px;">
                <div style="margin: 8px 0;font-weight: 600;">{{ $t('xiugaijilu') }}</div>
                <el-table :data="(yt.editObj && yt.editObj.editRecords) ? yt.editObj.editRecords : []" size="mini" border style="width: 100%">
                  <el-table-column :label="$t('xiugaishijian')" width="180">
                    <template #default="{ row }">
                      {{ row.updateTime ? dayjs(row.updateTime).format('YYYY-MM-DD HH:mm:ss') : '' }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="createByObject.nickname" :label="$t('xiugairen')" width="120"></el-table-column>
                  <el-table-column :label="$t('xiugaiqian')" width="180">
                    <template #default="{ row }">
                      {{ getMouthName(row.beforeShootMouthId) }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('xiugaihou')" width="180">
                    <template #default="{ row }">
                      {{ getMouthName(row.afterShootMouthId) }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('shimogongyi')">
              <div style="margin-bottom: 20px;">
                <el-select v-model="currentCraftParameterId" :placeholder="$t('qingxuanze')" size="mini" style="width: 300px !important;">
                  <el-option v-for="item in craftParameterList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div style="margin-bottom: 40px;">
                <div class="testMoldTable" v-html="gy" v-watermark="watermarkText"></div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('fenduancaiji')">
              <div style="margin-bottom: 20px;">
                <el-select v-model="currentCraftParameterId" :placeholder="$t('qingxuanze')" size="mini" style="width: 300px !important;">
                  <el-option v-for="item in craftParameterList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div style="margin-bottom: 40px;">
                <div class="testMoldTable" v-html="gy" v-watermark="watermarkText"></div>
              </div>
            </el-tab-pane>
          </el-tabs>

        </div>

      </template>
      <!-- 试模进度查看 -->
      <template v-else-if="yt.editObj && yt.editObj.action === 'shimojindu'">
        <div class="dialog-scroller">
          <el-descriptions :column="3" size="mini">
            <el-descriptions-item :label="$t('wuliaomingcheng') + '/' + $t('wuliaobianma')">
              {{ yt.editObj.material && yt.editObj.material.name }} / {{ yt.editObj.material && yt.editObj.material.code }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('mojumingcheng') + '/' + $t('mujubianma')">
              {{ yt.editObj.mould && yt.editObj.mould.name }} / {{ yt.editObj.mould && yt.editObj.mould.code }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('shezuimingcheng') + '/' + $t('shezuibianma')">
              <div style="display: flex;align-items: center;">
                <p> {{ yt.editObj.shootingMouth && yt.editObj.shootingMouth.name }} / {{ yt.editObj.shootingMouth && yt.editObj.shootingMouth.code }}<el-link type="primary" @click="updateShootingMouth()">{{ $t('xiugai') }}</el-link></p>
              </div>

            </el-descriptions-item>
            <el-descriptions-item :label="$t('danjuzhuangtai')">
              {{ $t(store.state.dictJsonAll['TRIAL_MOULD_WO_STATUS'][yt.editObj.status]) }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('shebeimingcheng') + '/' + $t('shebeibianma')">
              {{ yt.editObj.equipment && yt.editObj.equipment.name }} / {{ yt.editObj.equipment && yt.editObj.equipment.sn }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('lilungongyika')">
              <yi_upload :readOnly="true" :ids.sync="yt.editObj.fileIds" :limit="10"></yi_upload>
            </el-descriptions-item>
          </el-descriptions>
          <div style="padding: 40px 0px;">
            <el-steps :active="Number(yt.editObj.currentStep) - 1" align-center finish-status="success">
              <el-step title="空射调试">
                <template #description>
                  <span>
                    <span v-if="yt.editObj.stepOneFinishTime">{{ dayjs(yt.editObj.stepOneFinishTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                  </span>
                </template>
              </el-step>
              <el-step title="开始试模">
                <template #description>
                  <span>
                    <span v-if="yt.editObj.stepTwoFinishTime">{{ dayjs(yt.editObj.stepTwoFinishTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                  </span>
                </template>
              </el-step>
              <el-step title="分段采集">
                <template #description>
                  <span v-if="yt.editObj.stepThreeFinishTime">{{ dayjs(yt.editObj.stepThreeFinishTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                </template>
              </el-step>
              <el-step title="完成试模">
                <template #description>
                  <span v-if="yt.editObj.stepFourFinishTime">{{ dayjs(yt.editObj.stepFourFinishTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                </template>
              </el-step>
            </el-steps>
          </div>


          <div v-if="yt.editObj && (yt.editObj.currentStep == 1)">
            <div style="padding:20px 0px;">
              <div style="margin: 8px 0;font-weight: 600;">{{ $t('baojingshuju') }}</div>
              <el-table :data="(yt.editObj && yt.editObj.realTimeAlerts) ? yt.editObj.realTimeAlerts : []" size="mini" border style="width: 100%">
                <el-table-column type="index" :label="$t('xuhao')" width="60"></el-table-column>
                <el-table-column :label="$t('baojingxinxi')">
                  <template #default="{ row }">
                    {{ row.i18n ? $t(row.i18n) : row.code }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('baojingshijian')" width="180">
                  <template #default="{ row }">
                    {{ row.alarmTime ? dayjs(row.alarmTime).format('YYYY-MM-DD HH:mm:ss') : '' }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="padding:20px 0px;">
              <div style="margin: 8px 0;font-weight: 600;">{{ $t('xiugaijilu') }}</div>
              <el-table :data="(yt.editObj && yt.editObj.editRecords) ? yt.editObj.editRecords : []" size="mini" border style="width: 100%">
                <el-table-column :label="$t('xiugaishijian')" width="180">
                  <template #default="{ row }">
                    {{ row.updateTime ? dayjs(row.updateTime).format('YYYY-MM-DD HH:mm:ss') : '' }}
                  </template>
                </el-table-column>
                <el-table-column prop="createByObject.nickname" :label="$t('xiugairen')" width="120"></el-table-column>
                <el-table-column :label="$t('xiugaiqian')" width="180">
                  <template #default="{ row }">
                    {{ getMouthName(row.beforeShootMouthId) }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('xiugaihou')" width="180">
                  <template #default="{ row }">
                    {{ getMouthName(row.afterShootMouthId) }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <div id="testMoldTableExport" v-if="yt.editObj && (yt.editObj.currentStep == 2 || yt.editObj.currentStep == 3)" style="padding:20px 40px 20px 40px;margin-bottom: 20px;">
            <div class="testMoldTable" v-html="gy" v-watermark="watermarkText"></div>
          </div>
          <div v-if="yt.editObj && yt.editObj.currentStep == 4" style="padding:40px 0;text-align:center;">
            <i class="el-icon-success" style="font-size:48px;color:#67C23A;"></i>
            <div style="margin-top:12px;font-weight:600;">{{ $t('shimowancheng') }}</div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button v-if="yt.editObj && yt.editObj.currentStep != 4" size="mini" @click="yt.isShowEditDialog = false">{{ $t('guanbi') }}</el-button>
          <el-button v-if="yt.editObj && yt.editObj.currentStep == 1" :loading="yt.editObj.loading" size="mini" @click="nextStep()" type="primary">
            {{ $t('tijiaoxiayibu') }}
          </el-button>
          <template v-if="yt.editObj && (yt.editObj.currentStep == 2 || yt.editObj.currentStep == 3)">
            <yi_button size="mini" :onClick="previousStep">{{ $t('shangyibu') }}</yi_button>
            <yi_button size="mini" :onClick="exportData">{{ $t('daochu') }}</yi_button>
            <yi_button size="mini" :onClick="getLatestProcessParams">{{ $t('huoquzuixingongyicanshu') }}</yi_button>
            <yi_button size="mini" :onClick="saveCurrentProcessParams">{{ $t('baocundangqiangongyicanshu') }}</yi_button>
            <yi_button size="mini" :onClick="nextStep" type="primary">{{ $t('xiayibu') }}</yi_button>
          </template>
          <template v-if="yt.editObj && yt.editObj.currentStep == 4">
            <yi_button size="mini" :onClick="closeDialog">{{ $t('fanhuiliebiao') }}</yi_button>
            <yi_button size="mini" type="primary" :onClick="viewOrder">{{ $t('chakangongdan') }}</yi_button>
          </template>
        </span>
      </template>
    </el-dialog>
    <!-- 保存当前工艺参数弹框 -->
    <el-dialog :show-close="true" :title="$t('baocundangqiangongyicanshu')" :visible.sync="isShowSaveProcessDialog" :width="'400px'" :close-on-click-modal="false" append-to-body="append-to-body">
      <el-form ref="saveProcessForm" :model="saveProcessForm" size="mini" label-width="80px">
        <el-form-item :label="$t('mingcheng')" required>
          <el-input v-model="saveProcessForm.name" :placeholder="$t('qingshuru')"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowSaveProcessDialog = false">{{ $t('quxiao') }}</el-button>
        <yi_button size="mini" type="primary" :onClick="confirmSaveCurrentProcessParams">{{ $t('queding') }}</yi_button>
      </span>
    </el-dialog>
    <!-- 修改射嘴弹框 -->
    <el-dialog :show-close="true" :title="$t('xiugaishezuimingcheng')" :visible.sync="isShowUpdateShootingMouthDialog" :width="'400px'" :close-on-click-modal="false" append-to-body="append-to-body">
      <el-form :model="updateShootingMouthForm" size="mini" label-width="100px">
        <el-form-item :label="$t('shezuimingcheng')" required>
          <yi_data_select :type="'mouth'" :ids.sync="updateShootingMouthForm.afterShootMouthId"></yi_data_select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowUpdateShootingMouthDialog = false">{{ $t('quxiao') }}</el-button>
        <el-button :loading="updateShootingMouthLoading" size="mini" @click="confirmUpdateShootingMouth()" type="primary">
          {{ $t('queding') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import Yi_upload from '@/common/yi_upload/yi_upload.vue';
import Yi_button from '@/common/yi_button/yi_button.vue';
import html2canvas from 'html2canvas';
import dayjs from 'dayjs';

export default {
  name: 'web_test_mold_work_order_list',
  components: { Yi_button, Yi_upload },
  data() {
    return {
      watermarkText: this.store.state.organizations[0].name + '-' + this.store.state.user.nickname,
      gyHtml: "",
      gyValues: {},
      activeTab: '0', // 标签页索引
      craftParameterList: [],
      currentCraftParameterId: null,
      // 保存工艺参数弹框
      isShowSaveProcessDialog: false,
      saveProcessForm: { name: '' },
      createTimeStart: 0,
      createTimeEnd: 0,
      insertLoading: false,
      isShowUpdateShootingMouthDialog: false,
      updateShootingMouthForm: {
        afterShootMouthId: null
      },
      updateShootingMouthLoading: false,
      // 表单数据绑定到 yt.editObj
      columns: [
        {
          label: 'danjuzhuangtai',
          type: 'dictionary',
          key: 'TRIAL_MOULD_WO_STATUS',
          prop: 'status'
        },
        {
          label: 'shimojihuadanhao',
          prop: 'planNo'
        },
        {
          label: 'shezuibianma',
          prop: 'shootingMouth.code'
        },
        {
          label: 'shezuimingcheng',
          prop: 'shootingMouth.name'
        },
        {
          label: 'wuliaobianma',
          prop: 'material.code'
        },
        {
          label: 'wuliaomingcheng',
          prop: 'material.name'
        },
        {
          label: 'shebeibianma',
          prop: 'equipment.sn'
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name'
        },
        {
          label: 'mojubianma',
          prop: 'mould.code'
        },
        {
          label: 'mojumingcheng',
          prop: 'mould.name'
        },
        {
          label: 'lilungongyika',
          type: 'slot',
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 200,
          fixed: 'right'
        },

      ]
    };
  },
  directives: {
    watermark: {
      inserted(el, binding) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = 300;
        canvas.height = 200;
        ctx.font = '14px Arial';
        ctx.fillStyle = 'rgba(100, 100, 100, 0.3)'; // 水印颜色和透明度
        ctx.rotate((-20 * Math.PI) / 180); // 旋转角度
        let text = binding.value;
        if (text.length > 15) {
          let splitText = [];
          for (let i = 0; i < text.length; i += 15) {
            splitText.push(text.slice(i, i + 15));
          }
          text = splitText.join('\n');
        }
        // 保存初始的 y 坐标
        let y = 100;
        // 计算行高
        let lineHeight = parseInt(ctx.font, 10);
        // 增加行间距，这里设置为 5 像素
        let lineSpacing = 5;
        // 按行绘制文本并添加行间距
        text.split('\n').forEach((line, index) => {
          ctx.fillText(line, 50, y + index * (lineHeight + lineSpacing));
        });
        const imgData = canvas.toDataURL('image/png');
        el.style.backgroundImage = `url(${imgData})`;
        el.style.backgroundRepeat = 'repeat';
      }
    }
  },
  computed: {
    gy() {
      let str = this.gyHtml;
      str = this.base64.decode(str);

      let reg1 = /\[[^\]]*\]/g;
      str.match(reg1) &&
        str.match(reg1).map((code) => {
          let c = code.replace("[", "");
          c = c.replace("]", "");
          str = str.replace(code, this.$t(c));
        });
      let reg2 = /\{[^\}]*\}/g;
      str.match(reg2) &&
        str.match(reg2).map((code) => {
          let c = code.replace("{", "");
          c = c.replace("}", "");

          let value = this.gyValues[c];
          if (value == null) {
            str = str.replace(code, "");
          } else {
            str = str.replace(code, value);
          }
        });
      return str;
    },
  },
  watch: {
    activeTab(newVal) {
      // 当切换到试模工艺（索引1，步骤2）或分段采集（索引2，步骤3）时，请求数据
      if (newVal === '1' || newVal === '2') {
        const currentStep = newVal === '1' ? '2' : '3';
        // 如果模板数据不存在，先获取模板
        if (!this.gyHtml && this.yt.editObj && this.yt.editObj.equipmentId) {
          this.getTemplateData().then(() => {
            this.getCraftParameterList(currentStep);
          });
        } else {
          this.getCraftParameterList(currentStep);
        }
      }
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.orderBy = 'id desc';
      this.yt.get(1);

    }, 300);
  },

  methods: {

    exportExcel() {
      let params = this.yt.conditions;
      // params.materialId = this.yt.conditions.materialIdList;
      // params.equipmentId = this.yt.conditions.equipmentIdList;
      // params.status = this.yt.conditions.statusList;
      // delete params.materialIdList;
      // delete params.equipmentIdList;
      // delete params.statusList;
      // delete params.orderBy;
      return this.http
        .get('/web/report/export/aps_scheduling_log_export', { params })
        .then(res => {
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },

    // 获取实时报警
    getRealTimeAlerts() {

      this.http
        .get('/web/trial/mould/wo/alarm/realTime', { params: { equipmentId: this.yt.editObj.equipmentId, } })
        .then(res => {
          this.$set(this.yt.editObj, 'realTimeAlerts', Array.isArray(res.data) ? res.data : []);
        })
        .catch(() => {
          this.$set(this.yt.editObj, 'realTimeAlerts', []);
        });
    },
    // 获取修改记录
    getEditRecords() {
      if (!this.yt || !this.yt.editObj || !this.yt.editObj.id) {
        if (this.yt && this.yt.editObj) this.yt.editObj.editRecords = [];
        return;
      }
      this.http
        .get('/web/trial/mould/wo/shoot/mouth/edit/record/page', { params: { trialMouldWoId: this.yt.editObj.id, pageNum: 1, pageSize: 100 } })
        .then(res => {
          this.$set(this.yt.editObj, 'editRecords', Array.isArray(res.data && res.data.rows) ? res.data.rows : []);
        })
        .catch(() => {
          this.$set(this.yt.editObj, 'editRecords', []);
        });
    },
    // 提交下一步
    nextStep() {

      const params = {
        id: this.yt.editObj.id,
        currentStep: this.yt.editObj.currentStep
      };
      this.http
        .post('/web/trial/mould/wo/next/step', params)
        .then(res => {
          // 刷新当前弹框的数据
          this.refreshProgressDialog();
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },
    // 上一步
    previousStep() {
      const params = {
        id: this.yt.editObj.id,
        currentStep: this.yt.editObj.currentStep
      };
      this.http
        .post('/web/trial/mould/wo/previous/step', params)
        .then(res => {
          // 刷新当前弹框的数据
          this.refreshProgressDialog();
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },
    // 导出
    exportData() {
      const element = document.getElementById('testMoldTableExport');
      if (!element) {
        this.$message.warning(this.$t('qingxuanze'));
        return;
      }
      html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff'
      }).then(canvas => {
        const dataURL = canvas.toDataURL('image/png');
        if (dataURL !== '') {
          const a = document.createElement('a');
          a.download = this.$t('gongyicanshu') + '.png';
          a.href = dataURL;
          a.click();
        }
      }).catch(err => {
        this.$message.error(this.$t('daochushibai'));
      });
    },
    // 新增保存
    createWo() {
      const result = this.yt.req('POST', '/web/trial/mould/wo/create');
      if (result && typeof result.then === 'function') {
        result.then(() => {
          this.$message.success(this.$t('caozuochenggong'));
        }).catch(err => {
          this.$message.error(this.$t(err));
        });
      }
    },
    // 编辑保存
    updateWo() {
      const result = this.yt.req('POST', '/web/trial/mould/wo/update');
      if (result && typeof result.then === 'function') {
        result.then(() => {
          this.$message.success(this.$t('caozuochenggong'));
        }).catch(err => {
          this.$message.error(this.$t(err));
        });
      }
    },
    // 关闭弹窗（返回列表）
    closeDialog() {
      this.yt.isShowEditDialog = false;
    },
    // 查看工单
    viewOrder() {
      this.yt.get();
      this.activeTab = '0';
      this.yt.showEditDialog('chakan', this.yt.editObj, '80%');
      this.refreshProgressDialog()
    },
    // 获取最新工艺参数
    async getLatestProcessParams() {

      try {
        // 先获取设备工艺模板

        const templateRes = await this.http.get('/web/trial/mould/wo/template', {
          params: { equipmentId: this.yt.editObj.equipmentId }
        });
        console.log(templateRes.data.gy)
        this.gyHtml = templateRes.data.gy;
        // 然后获取所有工艺点的实时数据
        const realTimeRes = await this.http.get('/web/trial/mould/wo/point/value/realTime', {
          params: { equipmentId: this.yt.editObj.equipmentId }
        });
        this.gyValues = realTimeRes.data;

        this.$message.success(this.$t('caozuochenggong'));

        // 可以在这里处理返回的数据，比如保存到 yt.editObj 中
        // this.$set(this.yt.editObj, 'processTemplate', templateRes.data);
        // this.$set(this.yt.editObj, 'processRealTimeData', realTimeRes.data);
      } catch (err) {
        this.$message.error(this.$t(err));
      }
    },
    // 获取模板数据
    async getTemplateData() {
      if (!this.yt.editObj || !this.yt.editObj.equipmentId) {
        return Promise.resolve();
      }
      try {
        const templateRes = await this.http.get('/web/trial/mould/wo/template', {
          params: { equipmentId: this.yt.editObj.equipmentId }
        });
        this.gyHtml = templateRes.data.gy;
        return Promise.resolve();
      } catch (err) {
        console.error('获取模板数据失败', err);
        return Promise.resolve();
      }
    },
    // 获取工艺参数列表
    getCraftParameterList(currentStep) {
      this.craftParameterList = []
      this.currentCraftParameterId = null;

      this.http
        .get('/web/trial/mould/wo/craft/parameter/list', {
          params: {
            trialMouldWoId: this.yt.editObj.id,
            currentStep: currentStep
          }
        })
        .then(res => {
          const dataList = Array.isArray(res.data) ? res.data : [];
          this.craftParameterList = dataList;
          //如果当前工艺参数为空，则设置为第一个
          if (this.craftParameterList.length > 0) {
            this.currentCraftParameterId = dataList[0].id;
            this.gyValues = JSON.parse(dataList[0].value);
          }
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },
    // 保存当前工艺参数 -> 打开弹框
    saveCurrentProcessParams() {
      this.saveProcessForm.name = '';
      this.isShowSaveProcessDialog = true;
    },
    // 确认保存当前工艺参数
    confirmSaveCurrentProcessParams() {
      const params = { trialMouldWoId: this.yt.editObj.id, name: this.saveProcessForm.name, currentStep: this.yt.editObj.currentStep, value: JSON.stringify(this.gyValues) };
      this.http
        .post('/web/trial/mould/wo/craft/parameter/create', params)
        .then(() => {
          this.isShowSaveProcessDialog = false;
          this.$message.success(this.$t('caozuochenggong'));
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },

    // 刷新试模进度弹框数据
    refreshProgressDialog() {
      if (this.yt.editObj && this.yt.editObj.id) {
        this.http.get('/web/trial/mould/wo/page', { params: { id: this.yt.editObj.id } }).then(res => {
          Object.assign(this.yt.editObj, res.data.rows[0]);
          this.getCraftParameterList()
          this.getRealTimeAlerts();
          this.getEditRecords();
          this.getLatestProcessParams();
        });
      }
    },
    // 处理弹窗关闭事件
    handleDialogClose() {
      // 如果是试模进度弹窗，关闭时刷新列表
      if (this.yt.editObj && this.yt.editObj.action === 'shimojindu') {
        this.yt.get();
      }
    },
    // 修改射嘴
    updateShootingMouth() {
      if (this.yt.editObj.currentStep != 1) {
        this.$message.warning(this.$t('fanhuikongshetiaoshijieduan'));
        return;
      }
      this.updateShootingMouthForm.afterShootMouthId = this.yt.editObj.shootingMouthId;
      this.isShowUpdateShootingMouthDialog = true;
    },
    // 确认修改射嘴
    confirmUpdateShootingMouth() {
      if (!this.updateShootingMouthForm.afterShootMouthId) {
        this.$message.error(this.$t('qingxuanzeshezuimingcheng'));
        return;
      }
      this.updateShootingMouthLoading = true;
      const params = {
        trialMouldWoId: this.yt.editObj.id,
        afterShootMouthId: this.updateShootingMouthForm.afterShootMouthId
      };
      this.http
        .post('/web/trial/mould/wo/shoot/mouth/edit/record/create', params)
        .then(res => {
          this.isShowUpdateShootingMouthDialog = false;
          this.updateShootingMouthForm.afterShootMouthId = null;
          // 刷新数据
          this.yt.get(1);
          // 刷新当前弹框的数据
          if (this.yt.editObj && this.yt.editObj.id) {
            this.http.get('/web/trial/mould/wo/page', { params: { id: this.yt.editObj.id } }).then(res => {
              Object.assign(this.yt.editObj, res.data.rows[0]);
              this.getEditRecords();
            });
          }
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.updateShootingMouthLoading = false;
        });
    },
    // 从 store 获取射嘴名称
    getMouthName(mouthId) {
      if (!mouthId || !this.store.state.mouths || this.store.state.mouths.length === 0) {
        return '';
      }
      const mouth = this.store.state.mouths.find(item => item.id === mouthId);
      return mouth ? (mouth.name || mouth.code || '') : '';
    }
  }
};
</script>
